import React from 'react';
import styles from './styles.module.scss';

const TourTooltip = ({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  skipProps,
  isLastStep,
  size
}) => {
  return (
    <div {...tooltipProps} className={styles.tooltip}>
      {/* Header */}
      <div className={styles.tooltipHeader}>
        <h3 className={styles.tooltipTitle}>{step.title}</h3>
        <button {...closeProps} className={styles.closeButton} aria-label="Close tour">
          ✕
        </button>
      </div>

      {/* Content */}
      <div className={styles.tooltipContent}>
        <p>{step.content}</p>
      </div>

      {/* Footer */}
      <div className={styles.tooltipFooter}>
        {/* Progress indicator */}
        <div className={styles.progressIndicator}>
          Step {index + 1} of {size}
        </div>

        {/* Navigation buttons */}
        <div className={styles.buttonGroup}>
          {/* Skip button (always show) */}
          <button {...skipProps} className={styles.skipButton}>
            Skip Tour
          </button>

          {/* Back button (show if not first step) */}
          {index > 0 && (
            <button {...backProps} className={styles.backButton}>
              Back
            </button>
          )}

          {/* Next/Finish button */}
          <button {...primaryProps} className={styles.nextButton}>
            {isLastStep ? 'Finish Tour' : 'Next'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TourTooltip;
